import { LogIn, ShieldCheck } from "@/components/icons"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export function SignedOutPage() {
  const handleSignInAgain = () => {
    // Simply navigate to the app root. EasyAuth will enforce login, or
    // the app's auth flow will handle MSAL login if needed.
    window.location.href = window.location.origin
  }

  return (
    <section className="bg-background flex h-screen w-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mb-4 flex justify-center">
            <ShieldCheck className="text-foreground/70 h-12 w-12" />
          </div>
          <CardTitle className="text-2xl">You’re signed out</CardTitle>
          <CardDescription className="pt-2">
            Your session has ended. Sign in again to continue.
          </CardDescription>
        </CardHeader>
        <CardContent />
        <CardFooter className="flex justify-center">
          <Button onClick={() => void handleSignInAgain()}>
            <LogIn className="mr-2 h-4 w-4" />
            Sign in again
          </Button>
        </CardFooter>
      </Card>
    </section>
  )
}

SignedOutPage.displayName = "SignedOutPage"
